import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faBuilding,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css"; // Import the AOS stylesheet
import "animate.css";
import { Link } from "react-router-dom";
import GetInTouchForm from "../Website/GetInTouchForm";
import PaymentImage from "../../assets/about/contact.jpg";
import { Helmet } from "react-helmet-async";

const ContactUs = () => {
  // Initialize AOS when the component is mounted
  useEffect(() => {
    AOS.init();
  }, []);

  const mapSrc = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28034.198920090594!2d77.32807049999999!3d28.635801599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5006e8bbbe5%3A0xd117902e8f97b2d2!2sDeetya%20Soft%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1699613793621!5m2!1sen!2sin`;

  return (
    <>
      <Helmet>
        <title>
          Contact - Deetyasoft @ No. 09015350505 or Mail us to
          Info@deetyasoft.com
        </title>
        <meta
          name="description"
          content="Contact Deetya Soft at 9015350505 or info@deetyasoft.com. For support, reach us at support@deetyasoft.com or call +91 9717055088."
        />
        <meta
          name="keywords"
          content="How to contact Deetya Soft, Deetya Soft customer support number, Email address for Deetya Soft support, Deetya Soft Contact, Contact Deetya Soft, Deetya Soft Support, IVR Solutions Contact, IT Services Contact India, Email Deetya Soft, Deetya Soft Phone Number"
        />
        <link rel="canonical" href="https://deetyasoft.com/contact-us" />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://deetyasoft.com/contact-us" />
        <meta
          property="og:title"
          content="Contact - Deetyasoft @ No. 09015350505 or Mail us to Info@deetyasoft.com"
        />
        <meta
          property="og:description"
          content="Contact Deetya Soft at 9015350505 or info@deetyasoft.com. For support, reach us at support@deetyasoft.com or call +91 9717055088."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/contact.933792670ae776588b11.jpg"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://deetyasoft.com/contact-us" />
        <meta
          name="twitter:title"
          content="Contact - Deetyasoft @ No. 09015350505 or Mail us to Info@deetyasoft.com"
        />
        <meta
          name="twitter:description"
          content="Contact Deetya Soft at 9015350505 or info@deetyasoft.com. For support, reach us at support@deetyasoft.com or call +91 9717055088."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/contact.933792670ae776588b11.jpg"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}
        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Organization",
            name: "Deetya Soft Pvt Ltd",
            description:
              "Contact Deetya Soft at 9015350505 or info@deetyasoft.com. For support, reach us at support@deetyasoft.com or call +91 9717055088.",
            image:
              "https://deetyasoft.com/static/media/contact.933792670ae776588b11.jpg",
            logo: "https://www.deetyasoft.com/images/logo.png",
            url: "https://www.deetyasoft.com",
            telephone: ["+91-9015350505", "+91-9717055088"],
            email: "info@deetyasoft.com",
            sameAs: [
              "https://www.linkedin.com/company/deetya-soft-private-limited",
              "https://www.facebook.com/deetyasoftprivatelimited",
              "https://www.instagram.com/deetyasoft",
              "https://www.youtube.com/@deetyasoft",
              "https://www.crunchbase.com/organization/deetyasoft",
            ],
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
              addressLocality: "Ghaziabad",
              addressRegion: "Uttar Pradesh",
              postalCode: "201014",
              addressCountry: "IN",
            },
          })}
        </script>

        {/* Contact Points */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Organization",
            url: "https://www.deetyasoft.com",
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: "+91-981-862-7588",
                contactType: "technical support",
                areaServed: "IN",
              },
              {
                "@type": "ContactPoint",
                telephone: "+91-901-535-0505",
                contactType: "sales",
                areaServed: "IN",
              },
            ],
          })}
        </script>

        {/* Review Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Review",
            author: {
              "@type": "Person",
              name: "Parshan",
            },
            reviewBody:
              "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
            url: "https://www.deetyasoft.com/",
            description:
              "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
            datePublished: "2025-06-17",
            name: "Deetya Soft Pvt Ltd",
            reviewRating: {
              "@type": "Rating",
              worstRating: "1",
              ratingValue: "5",
              bestRating: "5",
            },
            itemReviewed: {
              "@type": "Organization",
              name: "Deetya Soft Pvt Ltd",
            },
          })}
        </script>
      </Helmet>
      {/* Hero Section */}

      <div
        className="relative text-center py-16  bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${PaymentImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="flex mx-auto items-center justify-center">
          <div className="relative max-w-3xl px-6 py-2">
            {/* <div className="absolute rounded-xl inset-0 bg-[rgba(0,0,0,0.2)]"></div> */}
            <div className="relative z-10 text-white drop-shadow-xl flex flex-col items-center justify-center h-full">
              <h1 className="md:text-4xl text-2xl font-semibold mb-4">
                Contact Us
              </h1>
              <div className="flex items-center space-x-2 text-sm md:text-base">
                <Link
                  to="/"
                  className="text-white  hover:text-main1 font-semibold"
                >
                  Home
                </Link>
                <span className="">
                  <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
                </span>
                <span className="text-gray-300 hover:text-main1">
                  {" "}
                  Contact Us
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        {/* Contact Info Section with BG */}
        <div className="w-full px-4 md:px-8 py-16 bg-white">
          {/* Section Heading */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 relative inline-block">
              <span className="text-main">Contact</span> & Join Together
              <div className="w-24 h-1 bg-main mx-auto mt-3 rounded-full"></div>
            </h2>
            <p className="text-gray-600 mt-4 max-w-xl mx-auto">
              We’re here to help you anytime. Reach out to us through any of the
              following ways and we’ll get back to you as soon as possible.
            </p>
          </div>

          {/* Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4  gap-8">
            {[
              {
                icon: faBuilding,
                title: "Visit Us At",
                subtitle: "Address:",
                content:
                  "1st Floor, Mahalaxmi Square, Plot no. C-1, Abhay Khand -2, Indirapuram, Ghaziabad, Uttar Pradesh - 201010",
              },
              {
                icon: faPhone,
                title: "Call Us On",
                subtitle: "24*7 SERVICE",
                content: "+91 9015350505\n+91 9717055088",
              },
              {
                icon: faEnvelope,
                title: "E-Mail Address",
                subtitle: "DROP A LINE",
                content: "info@deetyasoft.com\nsupport@ivrguru.com",
              },
              {
                icon: faClock,
                title: "Opening Time",
                subtitle: "OFFICE HOURS",
                content: "Mon - Sat: 10am - 6pm\nSunday: Closed",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl border cursor-pointer shadow-md p-6 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <div className="flex justify-center items-center mb-4">
                  <FontAwesomeIcon
                    icon={item.icon}
                    size="2x"
                    className="text-main"
                  />
                </div>
                <h5 className="text-xl font-semibold text-gray-800 mb-1">
                  {item.title}
                </h5>
                <p className="text-sm text-main font-medium uppercase mb-2">
                  {item.subtitle}
                </p>
                <p className="text-gray-600 text-sm whitespace-pre-line">
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className=" bg-gray-50">
        <div className="rounded-xl md:px-10 px-2 py-10 overflow-hidden ">
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-main mb-2">
            Our Location on the Map
          </h3>
          <p className="text-gray-600 text-base sm:text-lg mb-2">
            Find us easily on the map below. We’re located at a convenient spot
            for all your business needs.
          </p>
          <iframe
            className="w-full h-[350px] md:h-[400px] xl:h-[500px]"
            src={mapSrc}
            allowFullScreen
            loading="lazy"
            title="Google Maps Location"
          ></iframe>
        </div>
      </div>
      <div>
        <GetInTouchForm />
      </div>
    </>
  );
};

export default ContactUs;
